import { MediaType } from "../../types";
import { IAssetMetadata } from "./types";

/**
 * Base asset class that all provider-specific assets extend from.
 * Provides common utility methods and structure.
 */
export abstract class BaseAsset {
  /**
   * Utility method to add a path to a file URL
   * @param url - The base URL
   * @param path - The path to append
   * @returns The modified URL
   */
  protected addPathToFileUrl(url: URL, path: string): URL {
    url.pathname = `${url.pathname.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
    return url;
  }

  // Abstract methods that must be implemented by provider-specific classes
  public abstract getId(): string;
  public abstract getName(): string;
  public abstract setName(name: string): void | Promise<void>;

  public abstract getMediaType(): MediaType;
  public abstract getImageUrlForCard(size?: { width: number; height?: number }): string | Promise<string>;
  public abstract getPreviewUrl(size?: { width: number; height?: number }): string | Promise<string>;
  public abstract getDownloadUrl(): string | Promise<string>;

  /**
   * Get metadata about the asset
   * Default implementation returns minimal metadata
   */
  public getMetadata(): IAssetMetadata {
    return {
      status: 'unknown',
      date: '',
      size: 0,
    };
  }

  /**
   * Returns the workspace ID this asset belongs to.
   * Default implementation returns undefined (no workspace scope).
   */
  public getWorkspaceId(): string | undefined {
    return undefined;
  }

  /**
   * Returns the source identifier for this asset (e.g. 'user', 'workspace', 'zappar').
   * Default implementation returns empty string.
   */
  public getSource(): string {
    return '';
  }
}
